@if (toastService.toasts().length) {
<div
  id="toast-container"
  class="fixed top-20 end-13 z-9999 flex flex-col gap-3 w-105 pointer-events-none">
  @for (toast of toastService.toasts(); track toast.id) {
  <div
    class="animate-slide-in pointer-events-auto"
    [attr.data-toast-id]="toast.id">
    <div
      class="relative rounded-lg shadow-lg overflow-hidden transition-all duration-200 border border-(--color-border-neutral-soft)"
      [class.bg-white]="toast.type === ToastType.SUCCESS"
      [class.bg-red-100]="toast.type === ToastType.ERROR">
      <!-- Content -->
      <div class="flex items-center gap-3 p-4 h-full">
        <!-- Icon -->
        <div class="shrink-0">
          @if (toast.type === ToastType.SUCCESS) {
          <lib-success-toast-icon width="32" height="32" />
          } @else {
          <lib-error-toast-icon width="32" height="32" />
          }
        </div>

        <!-- Text Content -->
        <div class="flex-1 min-w-0">
          <p
            class="text-sm font-semibold leading-4 m-0"
            [class.text-green-800]="toast.type === ToastType.SUCCESS"
            [class.text-red-800]="toast.type === ToastType.ERROR">
            {{ toast.title }}
          </p>
          @if (toast.message) {
          <p
            class="text-xs font-normal leading-[0.875rem] m-0 mt-0.5 break-all"
            [class.text-green-700]="toast.type === ToastType.SUCCESS"
            [class.text-red-700]="toast.type === ToastType.ERROR">
            {{ toast.message }}
          </p>
          }
        </div>

        <!-- Close Button -->
        <button
          type="button"
          (click)="toastService.dismiss(toast.id)"
          class="shrink-0 inline-flex items-center justify-center w-6 h-6 transition-colors duration-150 outline-none"
          [class.text-green-700]="toast.type === ToastType.SUCCESS"
          [class.hover:text-green-900]="toast.type === ToastType.SUCCESS"
          [class.text-red-700]="toast.type === ToastType.ERROR"
          [class.hover:text-red-900]="toast.type === ToastType.ERROR"
          aria-label="Close toast">
          <svg
            class="w-4 h-4"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            stroke-width="2">
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>
      </div>
    </div>
  </div>
  }
</div>
}
